import { Loader2, AlertTriangle, ExternalLink } from "lucide-react";
import { CSE_FALLBACK_URL } from "@/constants/brand";

export function SearchResults({ status, resultsDivId, retry }) {
    return (
        <div className="w-full">
            {status === "error" && (
                <div
                    role="alert"
                    data-testid="search-error"
                    className="rounded-2xl p-6 mb-6 flex flex-col sm:flex-row sm:items-center gap-4"
                    style={{
                        border: "1px solid var(--ck-border)",
                        background: "#fff",
                    }}
                >
                    <AlertTriangle
                        style={{ color: "var(--ck-gold)" }}
                        aria-hidden="true"
                    />
                    <div className="flex-1">
                        <p
                            className="font-semibold"
                            style={{ color: "var(--ck-charcoal)" }}
                        >
                            The live search didn't load.
                        </p>
                        <p className="text-sm text-neutral-500">
                            You can retry, or open CaprioKnows search directly
                            on Google.
                        </p>
                    </div>
                    <div className="flex gap-3">
                        <button
                            type="button"
                            data-testid="search-retry"
                            onClick={retry}
                            className="rounded-full px-4 py-2 text-sm font-semibold text-white"
                            style={{ backgroundColor: "var(--ck-royal)" }}
                        >
                            Retry
                        </button>
                        <a
                            data-testid="search-fallback-link"
                            href={CSE_FALLBACK_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold"
                            style={{
                                border: "1px solid var(--ck-border)",
                                color: "var(--ck-charcoal)",
                            }}
                        >
                            Open fallback
                            <ExternalLink size={14} aria-hidden="true" />
                        </a>
                    </div>
                </div>
            )}

            {status === "loading" && (
                <div
                    data-testid="search-loading"
                    className="flex items-center justify-center gap-3 py-16"
                    style={{ color: "var(--ck-royal)" }}
                    aria-live="polite"
                >
                    <Loader2 className="animate-spin" aria-hidden="true" />
                    <span className="font-medium">Loading live results…</span>
                </div>
            )}

            {/* Google renders real results here (attribution, ads, pagination preserved) */}
            <div
                id={resultsDivId}
                className="ck-results"
                data-testid="results-container"
            />
        </div>
    );
}
